






import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../../base/components/system/mixins";
import { FormatStructureEditableMixin } from "../../mixins";
import { default as FormatPageEditor } from "../FormatPageEditor.vue";
import FormatValidator from "./FormatValidator.vue";

@Component({
  components: {
    FormatValidator,
  }
})
export default class OperatorsContainer extends Mixins(ModelEditableMixin, FormatStructureEditableMixin) {
  @Prop()
  toPageEditor: () => FormatPageEditor;

  $refs!: {
    validator: FormatValidator,
  };

  getCurrentPage(): FormatPageEditor {
    return this.toPageEditor();
  }

  getValidator(): FormatValidator {
    return this.$refs.validator;
  }
}
